import React, { ComponentProps } from "react";
import { SimpleGrid, SimpleGridProps } from "@chakra-ui/react";
import { TutorialCard } from "@components/Tutorials";
import { graphql } from "gatsby";

type HomePageTutorialGridProps = {
  showFeaturedBy?: boolean;
  tutorials: ReadonlyArray<
    Pick<Queries.Course, "id" | "featuredBy"> &
      ComponentProps<typeof TutorialCard>["tutorial"]
  >;
} & SimpleGridProps;

export function HomePageTutorialGrid({
  tutorials,
  showFeaturedBy,
  ...props
}: HomePageTutorialGridProps) {
  return (
    <SimpleGrid mt="8" minChildWidth={250} spacing="6" {...props}>
      {tutorials.map((tutorial) => (
        <TutorialCard
          key={tutorial.id}
          tutorial={tutorial}
          featuredBy={
            (showFeaturedBy ? tutorial.featuredBy : null) ?? undefined
          }
          pageSource="homepage"
        />
      ))}
    </SimpleGrid>
  );
}

export const query = graphql`
  fragment HomePageTutorial on Course {
    id
    slug
    title
    description
    status
    featuredBy
    type
    version
    thumb {
      src
      alt
    }
    lessons {
      tasks {
        id
      }
    }
  }
`;
